import { styled } from '@mui/material/styles'
import MuiTooltip, {
  TooltipProps as MuiTooltipProps,
  tooltipClasses
} from '@mui/material/Tooltip'

type TooltipProps = MuiTooltipProps & {
  maxWidth?: number | string
}

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <MuiTooltip {...props} classes={{ popper: className }} />
))((props) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: props.maxWidth || 300
  }
}))

export const Tooltip = (props: TooltipProps) => {
  const { children, ...rest } = props

  return <CustomWidthTooltip {...rest}>{children}</CustomWidthTooltip>
}

Tooltip.defaultProps = {
  checked: false,
  label: ''
}
